// services/apiClient.js
import axios from "axios";
import Cookies from "js-cookie";
// Create the axios client
const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Base URL without user ID for now
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// axiosClient.defaults.withCredentials = true;

console.log("REACT_APP_API_URL:", process.env.REACT_APP_API_URL);

// Request interceptor
// axiosClient.interceptors.request.use(
//   (config) => {
//     // Get the token from cookies
//     const token = Cookies.get("token");
//     const data = Cookies.get("id") ? JSON.parse(Cookies.get("id")) : null;

//     console.log("Cookies in request:", Cookies.get());
//     console.log("Cookies check in headers:", config.headers);
//     console.log("User data from cookies:", data);

//     // Set Authorization header if token exists
//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     }

//     // Dynamically add the user's ID to the URL if it exists
//     if (data && data.user_id) {
//       config.baseURL = `${process.env.REACT_APP_API_URL}/${data.user_id}`;
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// Response interceptor to handle flexible response data extraction
axiosClient.interceptors.response.use(
  (response) => {
    // Check if response has the nested data format
    if (response?.data?.data !== undefined) {
      return response.data.data;
    }
    // Check if response has a simpler data format
    if (response?.data !== undefined) {
      return response.data;
    }
    // If neither, return the full response
    return response;
  },
  (error) => Promise.reject(error)
);

export default axiosClient;
